import { useTranslation } from 'react-i18next'
import { Badge } from '../ui/badge'

const VARIANTS = {
  draft: 'secondary',
  due: 'info',
  overdue: 'destructive',
  paid: 'success',
  cancelled: 'outline',
} as const

export type InvoiceState = keyof typeof VARIANTS

/** BillingInvoiceBadge shows the computed payment state of an invoice (spec 2026-10-05-14). */
export function BillingInvoiceBadge({ state }: { state: string }) {
  const { t } = useTranslation('admin')
  const variant = VARIANTS[state as InvoiceState] ?? 'outline'
  return (
    <Badge variant={variant} data-testid="billing-invoice-state" data-state={state}>
      {t(`billing.invoices.state.${state}`, { defaultValue: state })}
    </Badge>
  )
}
